import { render, staticRenderFns } from "./OurHeritage.vue?vue&type=template&id=4ccfeb8b&scoped=true&"
import script from "./OurHeritage.vue?vue&type=script&lang=js&"
export * from "./OurHeritage.vue?vue&type=script&lang=js&"
import style0 from "./OurHeritage.vue?vue&type=style&index=0&id=4ccfeb8b&scoped=true&lang=scss&"
import style1 from "./OurHeritage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccfeb8b",
  null
  
)

export default component.exports